import request from '@/utils/request'

//  微信获取AppID
export function getAppId(query) {
  return request({
    url: '/shop/WxShopApplets/wxGetAppId',
    method: 'get',
    params: query
  })
}

//  设置AppID
export function settingAppId(data) {
  return request({
    url: '/shop/WxShopApplets/settingAppId',
    method: 'put',
    data: data
  })
}

// 设置基本信息
export function wxSetting(data) {
  return request({
    url: '/shop/WxShopApplets/wxSetting',
    method: 'post',
    data
  })
}

//  是否授权
export function wxAuth() {
  return request({
    url: '/shop/WxShopApplets/wxisAuthorization',
    method: 'get'
  })
}

//  微信获取授权码
export function wxGetweChatKey() {
  return request({
    url: '/shop/WxShopApplets/wxGetweChatKey',
    method: 'get'
  })
}

// 获取微信模板
export function wxTemplateList(query) {
  return request({
    url: '/shop/WxShopApplets/wxTemplateList',
    method: 'get',
    params: query
  })
}

// 设置模板id
export function wxTemplateSetting(query) {
  return request({
    url: '/shop/WxShopApplets/wxCommit',
    method: 'put',
    params: query
  })
}

// 配置小程序域名、权限
export function wxModifyServerDomain(query) {
  return request({
    url: '/shop/WxShopApplets/wxModifyServerDomain',
    method: 'get',
    params: query
  })
}

// 提交版本
export function wxSubmit(query) {
  return request({
    url: '/shop/WxShopApplets/wxSubmit',
    method: 'get',
    params: query
  })
}

// 发布版本
export function wxRelease(query) {
  return request({
    url: '/shop/WxShopApplets/wxRelease',
    method: 'get',
    params: query
  })
}

// 获取行业类型
export function wxGetCategory(query) {
  return request({
    url: '/shop/WxShopApplets/wxGetCategory',
    method: 'get',
    params: query
  })
}

/////////////add

// 小程序-获取行业父类
export function getCategoryParentList(query) {
  return request({
    url: '/shop/WxShopApplets/getCategoryParentList',
    method: 'get',
    params: query
  })
}

// 小程序-获取行业子类
export function getCategoryChildList(query) {
  return request({
    url: '/shop/WxShopApplets/getCategoryChildrenList',
    method: 'get',
    params: query
  })
}

// 小程序-设置行业
export function addCategory(data,shopCode) {
  return request({
    url: '/shop/WxShopApplets/addCategory',
    headers: {
      'shopCode': shopCode,
    },
    method: 'post',
    data: data
  })
}

// 小程序-获取已设置的行业
export function getSettingCategories(query) {
  return request({
    url: '/shop/WxShopApplets/getSettingCategories',
    method: 'get',
    params: query
  })
}

// 小程序-上传资质图片
export function uploadFile(query) {
  return request({
    url: '/shop/WxShopApplets/uploadFile',
    method: 'get',
    params: query
  })
}

// 小程序-配置权限域名
export function manageApplyPlugin(query,shopCode) {
  return request({
    url: '/shop/WxShopApplets/manageApplyPlugin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'shopCode': shopCode
    },
    method: 'get',
    params: query
  })
}

///////////
// 获取微信步骤
export function getWxStteing(query) {
  return request({
    url: '/shop/WxShopApplets/getwxStteing',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取主体性质
export function queryIcpSubjectTypes(query) {
  return request({
    url: '/shop/WxShopApplets/queryIcpSubjectTypes',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取负责人证件类型
export function queryIcpCertificateTypes(query) {
  return request({
    url: '/shop/WxShopApplets/queryIcpCertificateTypes',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取服务内容标志
export function queryIcpServiceContentTypes(query) {
  return request({
    url: '/shop/WxShopApplets/queryIcpServiceContentTypes',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取省市区
export function queryIcpDistrictCode(query) {
  return request({
    url: '/shop/WxShopApplets/queryIcpDistrictCode',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取前置审批
export function queryIcpNrlxTypes(query) {
  return request({
    url: '/shop/WxShopApplets/queryIcpNrlxTypes',
    method: 'get',
    params: query
  })
}

// 小程序备案-上传文件
export function uploadIcpMedia(data) {
  return request({
    url: '/shop/WxShopApplets/uploadIcpMedia',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}

// 小程序备案-管理员人脸核身
export function createIcpVerifyTask(query) {
  return request({
    url: '/shop/WxShopApplets/createIcpVerifyTask',
    method: 'get',
    params: query
  })
}

// 小程序备案-获取备案详情
export function getOnlineIcpOrder(query) {
  return request({
    url: '/shop/WxShopApplets/getOnlineIcpOrder',
    method: 'get',
    params: query
  })
}

// 小程序备案-小程序备案
export function applyIcpFiling(data,shopCode) {
  return request({
    url: '/shop/WxShopApplets/applyIcpFiling',
    headers: {
      'shopCode': shopCode
    },
    method: 'post',
    data: data
  })
}

// 小程序备案-撤回备案申请
export function cancelApplyIcpFiling(query) {
  return request({
    url: '/shop/WxShopApplets/cancelApplyIcpFiling',
    method: 'get',
    params: query
  })
}

// 小程序备案-备案状态
export function getIcpEntranceInfo(query) {
  return request({
    url: '/shop/WxShopApplets/getIcpEntranceInfo',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/register.js